"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuizData = void 0;
const QuizQuestion_1 = require("./QuizQuestion");
class QuizData {
    constructor(data) {
        this.link = null;
        this.isSurvey = false;
        this.votersCount = 0;
        this.votersCountDefault = 0;
        this.answerButtonLabel = "En savoir plus";
        this.validateButtonLabel = "Valider";
        this.allowMultipleAnswers = true;
        this.questions = [];
        this.hasAnswered = false;
        this.answeredIds = [];
        if (data) {
            data = (typeof data === "string") ? JSON.parse(data) : data;
            this.link = data.link;
            this.isSurvey = data.isSurvey;
            this.votersCount = data.votersCount;
            this.votersCountDefault = data.votersCountDefault;
            this.answerButtonLabel = data.answerButtonLabel || "En savoir plus";
            this.validateButtonLabel = data.validateButtonLabel || "Valider";
            this.allowMultipleAnswers = data.allowMultipleAnswers;
            this.questions = (typeof data.questions === 'undefined') ? [] : data.questions.map(q => new QuizQuestion_1.QuizQuestion(q));
            this.hasAnswered = (typeof data.hasAnswered === 'undefined') ? false : data.hasAnswered;
            this.answeredIds = (typeof data.answeredIds === 'undefined') ? [] : data.answeredIds;
        }
    }
    updateAnswersAndVotersCount(answersIds) {
        this.votersCount += 1;
        const percentageIncrement = (1 * this.votersCount) / 100;
        for (const i in this.questions) {
            if (answersIds.map((v) => parseInt(`${v}`)).indexOf(parseInt(`${this.questions[i].id}`)) > -1) {
                this.questions[i].percentage = Math.ceil(this.questions[i].percentage + percentageIncrement);
            }
            else {
                this.questions[i].percentage = Math.ceil(this.questions[i].percentage - percentageIncrement);
            }
        }
    }
}
exports.QuizData = QuizData;
//# sourceMappingURL=QuizData.js.map